<div class="row cnaf-slide-toggle" [formGroup]="personnesForm" >
    <div class="col-sm-12 form-group" >
        
        <!-- ALLOCATAIRE -->
        <app-personne
            name="personneDemandeur"
            [typePersonne]="typePersonneEnum.DEMANDEUR"
            [personneModel]="personneDemandeur"
            [nbEnfants]="nbEnfants"
            (personneModelChange)="recupererPersonneDemandeur($event)"
        >
        </app-personne>

        <!-- CONJOINT -->
        <app-personne *ngIf="isCouple"
            name="personneConjoint"
            [typePersonne]="typePersonneEnum.CONJOINT"
            [personneModel]="personneConjoint"
            [nbEnfants]="nbEnfants"
            (personneModelChange)="recupererPersonneConjoint($event)"
        >
        </app-personne>
        
    </div>
</div>
